import { AreaChart, LineChart, Line, Area, XAxis, YAxis, CartesianGrid, Legend, Tooltip, ResponsiveContainer,BarChart, Bar as Bbar } from 'recharts';
import AxiosURL from '../../ApiService/AxiosURL';
import React, {useEffect, useState} from 'react';
import Sidebar from '../layout/Sidebar';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Breadcrumb from './Breadcrumb';
// import { Legend } from 'chart.js';
import { UserContext } from "../../App";
import emitter from "./emitter"; 

import { Loader } from 'rsuite';
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default function Yield() 
{
  const [usevalue, setvalue] =useState();
  // console.log(usevalue);
  // API urls
  const yield_api = "farmers/farmer_yield";
  const irrigyield = "farmers/IrrigationYield";
  const gujaratyieldData = "farmers/GujratYield";
   
  //  use the hook for get and set the api data
  const [YieldDatas, setYieldDatas] = useState([]);
  // const [IrrigaYield, setIrrigYield] = useState([]);
  const [yieldKgPerHa, setYieldKgPerHa] = useState([]);
  const [labelData, setLabelData]=useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingForYield, setIsLoadingForYield] = useState(false);

  // use hook for call the function 
  useEffect(()=>{
    fetchPragatiDataApi(yield_api);
    Chart.register(ChartDataLabels);
    // fetchIrrigationYield(irrigyield);
    fetchyieldKgPerHa(gujaratyieldData);
    const lister = emitter.addListener("sendFilterData",districtDataFilter)
    return ()=>lister.remove();
  },[]);

  // define all functions
  const  fetchPragatiDataApi = async(url) =>{
    try{
      setIsLoading(true);
      let labelYear=[];
      let yieldData=[];
      const response = await AxiosURL.get(url);
      response.data.data.map((data)=>{
        labelYear.push(data.year)
        yieldData.push(data.yield)
      })
      setYieldDatas(yieldData);
      setLabelData(labelYear);
      setIsLoading(false);
    }catch(error){
      console.log(error);
    }
  }

  const fetchyieldKgPerHa = async(url) =>{
      setIsLoadingForYield(true);
      try {
        await AxiosURL.get(url).then((yieldData)=>{
          console.log("hhelo Ganesh")
          setYieldKgPerHa(yieldData.data.data);
          setIsLoadingForYield(false);
        }) 
      } catch (error) {
          if(error.response.status === 500) {
            console.log(error)
          } 
      }
  }
 // Ganesh was written the code
 const districtDataFilter = async (distData)=>{
  if(distData.district == 0)
  {
    fetchPragatiDataApi(yield_api);
    // fetchIrrigationYield(irrigyield);
    fetchyieldKgPerHa(gujaratyieldData);
  }else{
    setIsLoading(true);
    let labelYear=[];
    let yieldData=[];
    const response = await AxiosURL.get(yield_api,{ params:distData})
    response.data.data.map((data)=>{
      labelYear.push(data.year)
      yieldData.push(data.yield)
    })
    setYieldDatas(yieldData);
    setLabelData(labelYear);
    // console.info(response.data.data)
    // fetchIrrigationDataFilter(distData);
    fetchyieldKgPerHaDataFilter(distData);
    setIsLoading(false);
  }
}
// const fetchIrrigationDataFilter = async (distData)=>{
//   const resIrrigation = await AxiosURL.get(irrigyield,{ params:distData})
//   setIrrigYield(resIrrigation.data.data);
// }  
const fetchyieldKgPerHaDataFilter = async (distData)=>{
  // setIsLoadingForYield(true);
  // console.log("hhelo Ganesh")
  // await AxiosURL.get(yield_api,{ params:distData}).then((yieldData)=>{
  //   setYieldKgPerHa(yieldData.data.data);
  //   console.log("hhelo Ganesh")
  //   setIsLoadingForYield(false);
  // })

}
const setAvgDashboard1 = {
  
  labels: labelData,
  datasets: [
    {
      label: "Average yield Kg/Ha",
      backgroundColor: ["#fcb160","#8EDEE9","#FF5733","#FFE333","#A1E98E","#EC932F","#E98EDB"], 
      borderColor: "rgba(255,99,132,1)",
      borderWidth: 1,
      hoverBackgroundColor: "rgba(255,99,132,0.4)",
      hoverBorderColor: "rgba(255,99,132,1)",
      data: YieldDatas
    }
  ]
};
const options = {
  plugins: {
    datalabels: {
      display: true,
      color: "black",
      formatter: Math.round,
      anchor: "end",
      offset: -20,
      align: "start"
    },
    scales: {
      xAxes: [{
          barPercentage: 0.9
      }]
  }
  },
  legend: {
    display: false
  }
};

const axes = React.useMemo(
  () => [
    { primary: true, type: "time", position: "bottom" },
    { type: "linear", position: "left" }
  ],
  []
);


  return (
   <div className='wrapper'>
    <Sidebar />
    <div className='main'>
      <Header />
      <main className='content'>
        <div className='container-fluid p-0'>
        <section>
        <Breadcrumb setvalue={setvalue}/><br/>
          <div className='row'>    
          <div className='col col-md-12'>
            <div className='card graphCard'>
              <div className='card-body'>
                <b>Average yield Kg/Ha</b>
                  {isLoading ? <Loader size="md"/> : 
                  
                  <ResponsiveContainer width="95%" height={400}>
                    <Bar data={setAvgDashboard1} plugins={[ChartDataLabels]} options={options}  axes={axes} width={100} height={50} />
                  </ResponsiveContainer>
                  }
              </div>
            </div>
          </div>
          </div>
        
          <div className='row'>
            <div className='col col-md-8'>
              <div className='card graphCard'>
                <div className='card-body'>
                <b> Project yield vs State govt. yield (kg/ha)</b>
                <ResponsiveContainer width="95%" height={400}>
                  {isLoadingForYield ? <Loader size="md"/> : 
                        <BarChart
                          width={400}
                          height={400}
                          data={yieldKgPerHa}
                          margin={{
                            top: 15,
                            right: 30,
                            left: 20,
                            bottom: 5
                          }}
                          barSize={45}>
                          <XAxis dataKey="year" />
                          <YAxis />
                          <Tooltip cursor={false} />
                          <Legend />
                          <CartesianGrid strokeDasharray="3 3" />
                          <Bbar dataKey="goverment_yield" fill="#229af5 "  unit=" Kg/ha"/>
                          <Bbar dataKey="yield" fill="#FF9900"  unit=" Kg./ha"/>
                        </BarChart> 
                      }
                    </ResponsiveContainer>
               
                </div>
              </div>
            </div>
            <div className='col-md-4'>
                <div className='card graphCard'>
                  <div className='card-body'>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Year</th>
                        <th scope="col" style={{ backgroundColor: '#229af5', color:"#000000"}}>Goverment yield</th>
                        <th scope="col" style={{ backgroundColor: '#FF9900', color:"#000000"}}>Yield</th>
                      </tr>
                    </thead>
                    <tbody>
                    {yieldKgPerHa.map(( listValue, index ) => {
                    return (<tr key={index}>
                        <td >{listValue.year}</td>
                        <td style={{ backgroundColor: '#229af5', color:"#000000", height:"90px"}}>{listValue.goverment_yield}</td>
                        <td style={{ backgroundColor: '#FF9900', color:"#000000"}}>{listValue.yield}</td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                  </div>
                </div>
                </div>
          </div>
          <div className='footer'>
            <Footer />
          </div>
        </section>
        </div>
      </main>
    </div>
  </div>
  )
}

